module.exports = __webpack_public_path__ + "components/flag/static/square/pa-e0aca3f71ecb128e4b6bb5dbd1ddb2af.svg";